module.exports = __webpack_public_path__ + "static/heidi6-9f799731f66431ba98a35e8cd60f0fcc.jpg";